import { defaultWaitSettings } from 'components/ScenarioSetup/ActionSidebars/settings/defaultWaitSettings';
import { StringUse } from 'lib/StringUse';
import { DateUse } from 'lib/DateUse';

const {
    waitInterval,
    useTimeInterval,
    minDispatchTime,
    maxDispatchTime,
} = defaultWaitSettings();

export const waitDecompiler = actionOptions => {

    const {
        minutes_to_wait = waitInterval?.value,
        use_time_interval = useTimeInterval,
        time_to_send: { to_time, from_time } = { to_time: maxDispatchTime, from_time: minDispatchTime },
    } = actionOptions;

    const localFromTime = DateUse.convertUTCToLocal(from_time, 'HH:mm', 'HH:mm');
    const localToTime = DateUse.convertUTCToLocal(to_time, 'HH:mm', 'HH:mm');

    return {
        values: {
            waitInterval: {
                ...waitInterval,
                value: StringUse.falseyReturnEmptyString(minutes_to_wait, 'string'),
            },
            useTimeInterval: use_time_interval
        },
        minDispatchTime: StringUse.falseyReturnEmptyString(localFromTime),
        maxDispatchTime: StringUse.falseyReturnEmptyString(localToTime),
    }
}
